import React from "react";
import Dashboard from "../Dashboard/Dashboard";
import TenantSection from "../../Sections/Tenant";

const TenantComponent = () => {
  return <Dashboard sectionName={<TenantSection />} />;
};

export default TenantComponent;
